import { withPrefix } from 'gatsby'
import routesConfig from 'src/routes.config'

export default {
  metadata: {
    title: 'A private beta community for forward-thinking brokers and insurers. - artificial',
    desc: 'Join the Artificial Beta Community for insight, expertise and discussions with other forward-thinking insurers.',
  },
  ArHeroHeader: {
    title: 'Artificial Beta Community',
    description: 'A private beta community for forward-thinking brokers and insurers.',
    video: {
      alt: '',
      copyright: '',
      type: 'video/mp4',
      src: withPrefix('video/artificial-beta-community-720p.mp4'),
    },
    cta: {
      label: 'Join the community',
      onClick: {
        action: 'scrollToElement',
        id: '#beta-community-form',
        offsetTop: -100,
      },
    },
  },
  ArPostSimple: {
    title: 'Help us build the insurance tools of the future.',
    description: [
      'The best ideas come from collaboration. We’re building cutting-edge software to shape the future of insurance, but we want to know what your challenges are.',
      { tag: 'br' },
      { tag: 'br' },
      'That’s why we created the Artificial Beta Community - a place for forward-thinking insurers.',
      { tag: 'br' },
      { tag: 'br' },
      'Join us now for insight, expertise and discussions, and get exclusive early access to the next generation of insurance tools.',
    ],
  },
  Ar3ColFeatures: {
    title: 'Why join the Artificial Beta Community?',
    description: 'Membership comes with a whole host of benefits.',
    features: [
      {
        image: {
          alt: 'Product betas',
          url: withPrefix('img/ArPricingBenefits1.svg'),
        },
        title: 'Product betas',
        description: 'Early access to cutting-edge insurance software',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Partner opportunities',
          url: withPrefix('img/Ar3ColFeatures10.png'),
          url2: withPrefix('img/Ar3ColFeatures10@2x.png'),
        },
        title: 'Partner opportunities',
        description: 'Position your business at the forefront of insurance',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Workshops',
          url: withPrefix('img/ArPricingBenefits3.svg'),
        },
        title: 'Workshops',
        description: 'Product feature workshops to get your business on board',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Discounts',
          url: withPrefix('img/Ar3ColFeatures11.png'),
          url2: withPrefix('img/Ar3ColFeatures11@2x.png'),
        },
        title: 'Discounts',
        description: 'Discounted pricing for early adopters',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Priority features',
          url: withPrefix('img/Ar3Columns3.png'),
          url2: withPrefix('img/Ar3Columns3@2x.png'),
        },
        title: 'Priority features',
        description: 'Prioritisation of features on our product roadmaps',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Slack workspace',
          url: withPrefix('img/Ar3ColFeatures2.png'),
          url2: withPrefix('img/Ar3ColFeatures2@2x.png'),
        },
        title: 'Slack workspace',
        description: 'Chat to us one-on-one for frictionless collaboration',
        scHideOnMobile: false,
      },
    ],
  },
  ArDynamicForm: {
    form: {
      request: {
        url: process.env.BETA_CONTACT_FORM,
      },
      buttonTitle: 'Apply now',
      buttonTitleSuccess: 'Application Received!',
      successDescription: 'You’ll receive an email shortly',
      fields: [
        {
          tag: 'input',
          type: 'text',
          name: 'full_name',
          label: 'Full Name',
          placeholder: '',
          required: true,
          rules: {
            minLength: 2,
          },
        },
        {
          tag: 'input',
          type: 'email',
          name: 'email',
          label: 'Email Address',
          placeholder: '',
          required: true,
          rules: {
            minLength: 2,
          },
        },
        {
          tag: 'input',
          type: 'text',
          name: 'invite_code',
          label: 'Invite Code (optional)',
          placeholder: '',
          required: false,
        },
      ],
    },
    footerText: [
      'By signing up, you agree to receive occasional emails from us as part of the Artificial Beta Community. We will not sell or distribute your email address to any third party at any time. View our ',
      { tag: 'Link', options: { innerText: 'Privacy Policy.', attrs: { to: routesConfig.company.privacy() } } },
    ],
  },
  ArSocialSection: {
    title: 'Follow us for a glimpse inside the future of insurance.',
    backgroundColor: '#161616',
    social: [
      {
        icon: 'twitter',
        link: 'https://twitter.com/artificiallabs',
      },
      {
        icon: 'linkedin',
        link: 'https://www.linkedin.com/company/artificiallabs/',
      },
      {
        icon: 'instagram',
        link: 'https://www.instagram.com/artificiallabs/',
      },
    ],
  },

}
